import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { firstValueFrom } from 'rxjs';
import { AuthPageLayoutComponent } from '../../../shared/layout/auth-page-layout/auth-page-layout.component';
import { LabelComponent } from "../../../shared/components/form/label/label.component";
import { InputFieldComponent } from "../../../shared/components/form/input/input-field.component";
import { ButtonComponent } from "../../../shared/components/ui/button/button.component";
import { AuthService } from "../../../shared/services/auth.service";
import { ToastService } from "../../../shared/services/toast.service";

@Component({
  selector: 'app-reset-password',
  imports: [AuthPageLayoutComponent, LabelComponent, InputFieldComponent, ButtonComponent],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  token = '';
  newPassword = ''
  confirmPassword = ''
  isSubmitting = false;
  resetSuccess = false;

  get canSubmit(): boolean {
    return !this.isSubmitting;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
  }

  async onResetPassword() {
    this.isSubmitting = true;

    try {
      await firstValueFrom(
        this.authService.resetPassword(
          this.token,
          this.newPassword,
          this.confirmPassword,
          { suppressErrorToast: true }
        )
      );
      this.resetSuccess = true;
    } catch (error: any) {
      const message = error?.error?.message || error?.message || 'Unable to reset password.';
      this.toastService.error(message);
    } finally {
      this.isSubmitting = false;
    }
  }

  onResetPasswordBack() {
    this.router.navigate(['/signin']);
  }
}